import React from "react";
import { Routes, Route, useLocation,Navigate } from "react-router-dom";
import './Global.css';
 // Needed to check auth status at App level
import ProtectedRoute from "./auth/helper/ProtectedRoute";

import LoginPage from './login/LoginPage';
import LandingPage from './LandingPage';
import PricingPage from './pricing/PricingPage';
import DashboardPage from './dashboard/DashboardPage';

import Layout from './email-notifications/email-layout/Layout';
import EmailNotificationSentPage from './email-notifications/email-notificaion-sent/EmailNotificationSentPage';
import EmailTemplatePage from './email-notifications/email-template/EmailTemplatePage';
import EmailCategoryPage from './email-notifications/email-category/EmailCategoryPage';
import EmailTemplateVariablePage from './email-notifications/email-template-variable/EmailTemplateVariablePage';
import EmailSystemVariablePage from './email-notifications/email-system-variable/EmailSystemVariablePage';
import EmailAddCorpSenderCredPage from './email-notifications/email-add-sender-cred/EmailAddCorpSenderCredPage';
import EmailSendManualTriggerPage from './email-notifications/email-send-manual-trigger/EmailSendManualTriggerPage';



import WaLayout from "./whatsapp/layout/WaLayout";
import WaNotificationSentPage from './whatsapp/wa-notification-sent/WaNotificationSentPage';
import WaTemplatePage  from './whatsapp/wa-template/WaTemplatePage';
import WaCategoryPage from './whatsapp/wa-category/WaCategoryPage';
import WaTemplateVariablePage from './whatsapp/wa-template-variable/WaTemplateVariablePage';
import WaSystemVariablePage from './whatsapp/wa-system-variable/WaSystemVariablePage';
import ClientDetailsPage from './whatsapp/wa-client-details/ClientDetailsPage';
import WaClientPortfolioDetailsPage from './whatsapp/wa-client-portfolio-details/WaClientPortfolioDetailsPage';
import WaAppDetailsPage from './whatsapp/wa-app-details/WaAppDetailsPage';
import WabaDetailsPage from './whatsapp/waba-details/WabaDetailsPage';
import WabaSenderDetails from './whatsapp/wa-senders/WabaSenderDetails';
import WaUserProfilePage from './whatsapp/wa-user-profile/WaUserProfilePage';
import WaMyProfilePage from './whatsapp/wa-user-profile/WaMyProfilePage';
import WaEmbededSignupPage from './whatsapp/wa-embeded-signup/WaEmbededSignupPage';
import WaUserInterestPage from './whatsapp/wa-user-interest/WaUserInterestPage';
import WaDashboardPage from './whatsapp/wa-dashboard/WaDashboardPage';
import WaPiiAuditLogPage from './whatsapp/wa-pii-audit/WaPiiAuditLogPage';
import WaUserConsentPage from './whatsapp/wa-user-consent/WaUserConsentPage';

import SmsLayout from "./sms/layout/SmsLayout";
import SmsNotificationSentPage from './sms/sms-notification-sent/SmsNotificationSentPage';
import SmsTemplatePage  from './sms/sms-template/SmsTemplatePage';
import SmsCategoryPage from './sms/sms-category/SmsCategoryPage';
import SmsSenderModelPage from './sms/sms-sender-model/SmsSenderModelPage';
import SmsTemplateVariablePage from './sms/sms-template-variable/SmsTemplateVariablePage';
import SmsSystemVariablePage from './sms/sms-system-variable/SmsSystemVariablePage';


import VoiceLayout from "./voice/layout/VoiceLayout";
import VoiceNotificationSentPage from "./voice/voice-notification-sent/VoiceNotificationSentPage";
import VoiceTemplatePage  from './voice/voice-template/VoiceTemplatePage';
import VoiceCategoryPage from './voice/voice-category/VoiceCategoryPage';
import VoiceTemplateVariablePage from './voice/voice-template-variable/VoiceTemplateVariablePage';
import VoiceSystemVariablePage from './voice/voice-system-variable/VoiceSystemVariablePage';


function App() {
  
  const location = useLocation();
  
  // 2. Define authentication status based on token presence
  

  // 3. Log current state for debugging
  console.log(`APP.JS RENDER: path=${location.pathname}`);

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/landing" element={<LandingPage />} />
      <Route path="/pricing" element={<PricingPage />} />

      {/* The base address (just the domain): the WhatsApp dashboard for a signed-in user, the very same page as /login for anyone else */}
      <Route path="/" element={<ProtectedRoute loggedOut={<LoginPage />} />}>
        <Route index element={<WaDashboardPage/>} />
      </Route>

      {/* --- Protected Routes --- */}
      {/* --- ALL PROTECTED ROUTES GO INSIDE THIS NESTED GROUP --- */}
      <Route element={<ProtectedRoute />}>
        {/*<Route path="/" element={<DashboardPage />} />*/}
        {/*<Route path='/dashboard' element={<DashboardPage/>} />*/}
        {/* Where a signed-in user lands: the WhatsApp dashboard (the gateway redirects here after a successful login) */}
        <Route path='/wadashboard' element={<WaDashboardPage/>} />

        {/* EMAIL section */}
        <Route path="email" element={<Layout />}>
          <Route index element={<EmailNotificationSentPage />} />
          <Route path="email-template" element={<EmailTemplatePage/>} />
          <Route path="email-category" element={<EmailCategoryPage/>} />
          <Route path="email-template-variable" element={<EmailTemplateVariablePage/>} />
          <Route path="email-system-variable" element={<EmailSystemVariablePage/>} />
          <Route path="email-add-corp-sender-cred" element={<EmailAddCorpSenderCredPage/>} />
          <Route path="email-send-manual-trigger" element={<EmailSendManualTriggerPage/>} />
        </Route>

        {/* SMS section */}
        <Route path="sms" element={<SmsLayout />}>
          <Route index element={<SmsNotificationSentPage />} />
          <Route path="sms-template" element={<SmsTemplatePage/>} />
          <Route path="sms-category" element={<SmsCategoryPage/>} />
          <Route path="sms-sender-model" element={<SmsSenderModelPage/>} />
          <Route path="sms-template-variable" element={<SmsTemplateVariablePage/>} />
          <Route path="sms-system-variable" element={<SmsSystemVariablePage/>} />
        </Route>

        {/* WA section */}
        <Route path="whatsapp" element={<WaLayout />}>
          <Route index element={<WaNotificationSentPage />} />
          <Route path="user-consent" element={<WaUserConsentPage/>} />
          <Route path="user-interest" element={<WaUserInterestPage/>} />
          <Route path="wa-template" element={<WaTemplatePage/>} />
          <Route path="wa-category" element={<WaCategoryPage/>} />
          <Route path="wa-template-variable" element={<WaTemplateVariablePage/>} />
          <Route path="wa-system-variable" element={<WaSystemVariablePage/>} />
          <Route path="client-details" element={<ClientDetailsPage/>} />
          <Route path="wa-client-portfolio-details" element={<WaClientPortfolioDetailsPage/>} />
          <Route path="wa-app-details" element={<WaAppDetailsPage/>} />
          <Route path="waba-details" element={<WabaDetailsPage/>} />
          <Route path="wa-senders" element={<WabaSenderDetails/>} />
          <Route path="wa-user-profile" element={<WaUserProfilePage/>} />
          <Route path="my-profile" element={<WaMyProfilePage/>} />
          <Route path="wa-embeded-signup" element={<WaEmbededSignupPage/>} />
          <Route path="pii-audit-log" element={<WaPiiAuditLogPage/>} />
        </Route>

        {/* Voice section */}
        <Route path="voice" element={<VoiceLayout />}>
          <Route index element={<VoiceNotificationSentPage />} />
          <Route path="voice-template" element={<VoiceTemplatePage/>} />
          <Route path="voice-category" element={<VoiceCategoryPage/>} />
          <Route path="voice-template-variable" element={<VoiceTemplateVariablePage/>} />
          <Route path="voice-system-variable" element={<VoiceSystemVariablePage/>} />
        </Route>
      </Route>

       {/* Catch-all */}
      {/* If no route matches, we send them to the root where ProtectedRoute 
          will either push them to /dashboard or trigger a login */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;


